/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { PatchedServiceOrderEditRequest } from '../types/PatchedServiceOrderEdit';
import type { ServiceOrderEditResponse } from '../types/ServiceOrderEdit';

export type ServiceOrdersPartialUpdateRequest = PatchedServiceOrderEditRequest;
export type ServiceOrdersPartialUpdateResponse = ServiceOrderEditResponse;

export type ServiceOrdersPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this service order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/service_orders/{id}/
 *
 * ```yaml
 * operationId: service_orders_partial_update
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderEdit'
 *     description: ''
 * ```
 */
export const serviceOrdersPartialUpdateOperation = ({
  id,
  ...rest
}: ServiceOrdersPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/service_orders/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/service_orders/{id}/' };
  };

/**
 * PATCH /dmx-server/service_orders/{id}/
 *
 * ```yaml
 * operationId: service_orders_partial_update
 * tags:
 *   - service_orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/PatchedServiceOrderEdit'
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/ServiceOrderEdit'
 *     description: ''
 * ```
 */
export const serviceOrdersPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: ServiceOrdersPartialUpdateQuery;
  request: PatchedServiceOrderEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<ServiceOrderEditResponse>> => {
  const operation = serviceOrdersPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
